import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useTranslation } from '../../../hooks/useTranslation';
import AlertBellIcon from '../../../images/AlertsBell.png';
import { navigate } from 'gatsby';
import ROUTES from '../../../routes';
import mainColors from '../../../themes/main-colors';

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: mainColors.white,
    color: mainColors.noirBlur,
  },
  topSection: {
    padding: theme.spacing(3, 2.75, 4),
    minHeight: 150,
    boxSizing: 'border-box',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  iconCircle: {
    width: 32,
    height: 32,
    minWidth: 32,
    borderRadius: '50%',
    border: '2px solid #e67a00',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.25),
    boxSizing: 'border-box',
  },
  title: {
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 400,
    paddingLeft: theme.spacing(1),
  },
  description: {
    fontSize: 16,
    lineHeight: 'normal',
    color: mainColors.black,
  },
  ctaSection: {
    backgroundColor: mainColors.lightBlue1,
    minHeight: 60,
    padding: theme.spacing(0, 2.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  ctaText: {
    fontSize: 16,
    fontWeight: 600,
  },
  chevronIcon: {
    fontSize: 26,
  },
}));

const ManageAlerts = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Paper className={classes.card}>
      <Box className={classes.topSection}>
        <Box className={classes.headerRow}>
          <Box className={classes.iconCircle}>
            <img alt={''} src={AlertBellIcon} />
          </Box>

          <Typography className={classes.title} variant="h3">
            {t('ALERTS_AND_REMINDERS_LABEL')}
          </Typography>
        </Box>

        <Typography className={classes.description}>
          {t('ALERTS_AND_REMINDERS_SUBHEADING')}
        </Typography>
      </Box>

      <Box
        className={classes.ctaSection}
        onClick={() => navigate(ROUTES.MANAGE_ALERTS)}
      >
        <Typography className={classes.ctaText}>
          {t('MANAGE_ALERTS_AND_REMINDERS')}
        </Typography>

        <ChevronRightIcon className={classes.chevronIcon} />
      </Box>
    </Paper>
  );
};

export default ManageAlerts;
